import { render, staticRenderFns } from "./AllSignalTabs.vue?vue&type=template&id=67be1046"
import script from "./AllSignalTabs.vue?vue&type=script&lang=js"
export * from "./AllSignalTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports